import {RecodeSpinResult} from '@fantasmagames/slot/src/logic/integration/RecodeSpinResult';
import {SymbolPosition} from '@fantasmagames/slot/src/modules/reels/ReelConstants';
import {GameSymbol} from '@fantasmagames/slot/src/modules/reels/data/GameSymbol';
import {Symbols} from 'src/reels/Symbols';
import {RecodeToPrototypeConverter} from 'src/logic/recode/RecodeToPrototypeConverter';

export class GameRecodeSpinResult extends RecodeSpinResult {
	protected makeGameSymbolFrom(symbol: number, symbolHeight: number = 1, position: SymbolPosition): GameSymbol {
		if (symbol >= 0) {
			return new GameSymbol(
				RecodeToPrototypeConverter.recodeToGameSymbol(symbol),
				{
					width: 1,
					height: 1,
				},
				position,
			);
		}

		return null;
	}

	protected convertPaytableReasonToSymID(reason: string): number {
		const id = reason.substr(1);

		switch (id) {
			case 'M1':
				return Symbols.M1; // H1
			case 'M2':
				return Symbols.M2; // H2
			case 'M3':
				return Symbols.M3; // H3
			case 'M4':
				return Symbols.M4; // H4
			case 'M5':
				return Symbols.M5; // L1
			case 'F6':
				return Symbols.F6; // L2
			case 'F7':
				return Symbols.F7; // L3
			case 'F8':
				return Symbols.F8; // L4
			case 'F9':
				return Symbols.F9; // L5

			default:
				break;
		}
	}

}



// WEBPACK FOOTER //
// ./src/logic/recode/GameRecodeSpinResult.ts